import React from "react";
import QuestionPaperUI from "./QuestionPaperUI";
import { Box } from "@mui/material";
import CodeUI from './CodeUI.js'
export default function ChatArea({ messages = [] }) {
  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        
        px: 3,
        py: 2,
      
      }}
      
    >
      {messages.map((msg, i) =>
        msg.role === "user" ? (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mb: 2
            }}
          >
            <Box
              sx={{
                background: "#4b97f0",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                borderRadius: "16px",
                px: 1.5,
                py: 1,
                color:"white",
                maxWidth: "70%"
              }}
            >
              {msg.content}
            </Box>
          </Box>
        ) : (
          <Box key={i} sx={{ mb: 2 }}>
             {msg.content.type === "code" ? (
        <CodeUI
          explanation={msg.content.text.explanation}
          code={msg.content.text.code}
        />
      ) : msg.content.type === "question_paper" ?(
  <QuestionPaperUI jobId={msg.content.text.guid} />
):(
        <Box
          dangerouslySetInnerHTML={{ __html: msg.content.text }}
          sx={{
            color: "#0d162b",
            lineHeight: 1.7,
            maxWidth: "70%",
            borderRadius: "16px",
          }}
        />
      )}
    </Box>
          //   <Box
          //     dangerouslySetInnerHTML={{ __html: msg.content }}
          //     sx={{
          //       color: "#0d162b",
          //       lineHeight: 1.7,
          //       maxWidth: "70%",
          //       borderRadius: "16px",
          //     }}
          //   />
          // </Box>
        )
      )}
    </Box>
  );
}
